<template>
  <div>
    <div class="atcc-right-bar">
      <simplebar class="h-100">
        <div class="rightbar-title px-3 py-4 d-flex">
          <h5 class="m-0">ATCC Filters</h5>
          <a href="javascript:void(0);" class="atcc-right-bar-toggle ms-auto" @click="$emit('close')">
            <i class="mdi mdi-close noti-icon"></i>
          </a>
        </div>
        <hr class="mt-0" />
        <div class="p-3">
          <h6 class="mb-2">From Date:</h6>
          <div class="input-group mb-3">
            <date-picker v-model="filterSelect.datepickervalueFrom" :first-day-of-week="1"
              :disabled-date="(date) => date >= new Date()" lang="en" placeholder="Choose From Date"></date-picker>
          </div>

          <h6 class="mb-2">To Date:</h6>
          <div class="input-group mb-3">
            <date-picker v-model="filterSelect.datepickervalueTo" :first-day-of-week="1" :disabled-date="(date) =>
              date < new Date(filterSelect.datepickervalueFrom) || date >= new Date()
              " lang="en" placeholder="Choose To Date"></date-picker>
          </div>

          <h6 class="mb-2">Vehicle No:</h6>
          <div class="input-group mb-3">
            <b-form-input v-model="filterSelect.filterVehicleNumber" class="form-control"
              placeholder="Search by Vehicle No." maxlength="10"></b-form-input>
          </div>

          <h6 class="mb-2">Vehicle Class:</h6>
          <div class="input-group mb-3">
            <v-select placeholder="Select Vehicle Class" class="col-12 style-chooser" v-model="filterSelect.vehicleClass"
              :options="vehicleClassOptions" label="class_name" :reduce="(category) => category.id"></v-select>
          </div>

          <h6 class="mb-2">Location:</h6>
          <div class="input-group mb-3">
            <v-select placeholder="Select Location" class="col-12 style-chooser" v-model="filterSelect.location"
              :options="locationOptions" label="location" :reduce="(data) => data.location"></v-select>
          </div>

          <h6 class="mb-2">Speed (km/hr):</h6>
          <div class="input-group mb-3 row">
            <div class="col-12">
              <vue-range-slider ref="slider" :min="0" :max="500" :step="10" direction="horizontal"
                v-model="filterSelect.speedFilter" :speed="0.5" :start-animation="true"></vue-range-slider>
            </div>
          </div>
          
          <h6 class="mb-2">Side:</h6>
          <div class="input-group mb-3">
            <v-select placeholder="Select Side" class="col-12 style-chooser" v-model="filterSelect.side"
              :options="['LHS', 'RHS']" label="side"></v-select>
          </div>

          <h6 class="mb-2">Site:</h6>
          <div class="input-group mb-3">
            <v-select placeholder="Select Site" class="col-12 style-chooser" v-model="filterSelect.site"
              :options="sitesFilters" label="site" :reduce="(data) => data.site"></v-select>
          </div>

          <!-- <h6 class="mb-2">Speed (km/hr):</h6>
          <div class="input-group mb-3 row">
            <div class="col-12">
              <vue-range-slider ref="slider" :min="0" :max="500" :step="10" direction="horizontal"
                v-model="filterSelect.speedFilter" :speed="0.5" :start-animation="true"></vue-range-slider>
            </div>
          </div> -->

          <hr class="mt-0" />
          <b-button class="btn btn-success btn-block btn-rounded w-100 mb-2"
            @click="$emit('getFilteredRecords', JSON.stringify(filterSelect))"><i
              class="fa fa-check me-2"></i>Filter</b-button>
          <b-button variant="outline-danger" class="btn btn-block btn-rounded w-100" @click="resetFilter" block><i
              class="fa fa-times me-2"></i>Reset</b-button>
        </div>
      </simplebar>
    </div>
    <!-- Right bar overlay-->
    <div class="atcc-rightbar-overlay"></div>
  </div>
</template>
<script>
import simplebar from "simplebar-vue";
import DatePicker from "vue2-datepicker";
import "../../assets/plugins/range-slider/vue-range-slider.css";
import VueRangeSlider from "../../assets/plugins/range-slider/vue-range-slider";

/**
 * Right sidebar component
 */
export default {
  components: {
    simplebar,
    DatePicker,
    VueRangeSlider,
  },
  props: {
    vehicleClassOptions: Array,
    locationOptions: Array,
    sitesFilters: Array,
  },
  data() {
    return {
      filterSelect: {
        datepickervalueFrom: null,
        datepickervalueTo: null,
        speedFilter: [0, 500],
        location: null,
        filterVehicleNumber: null,
        vehicleClass: null,
        side: null,
        site: null,
      },
    };
  },
  methods: {
    resetFilter() {
      this.filterSelect = {
        datepickervalueFrom: null,
        datepickervalueTo: null,
        speedFilter: [0, 500],
        location: null,
        filterVehicleNumber: null,
        vehicleClass: null,
        side: null,
        site: null,
      };

      this.$emit("resetFilter");
    },
  },
};
</script>
